/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { isMobile } from 'react-device-detect'
import useRootStore from '@store/useRootStore'
//img
import TopPageImg from '@assets/images/voc/voc-page/top-img.png'
import VocImg01 from '@assets/images/voc/voc-page/voc-img-01.png'
import VocImg02 from '@assets/images/voc/voc-page/voc-img-02.png'
import VocImg03 from '@assets/images/voc/voc-page/voc-img-03.png'
import CheckOff from '@assets/images/voc/check-off.png'
import CheckOn from '@assets/images/voc/check-on.png'
import { ArrowIco } from '@shared/Icon/ArrowIcon'
//css
import { TitleWrap } from '@styles/base.style'
import { BackBtn, Button } from '@styles/button.style'
import { useOnMount, useOnUnmount } from '@utils/reactExt'
import { VocPageWrap } from './index.style'
import { appScrollTo } from '@utils/utils'

const VocPage: React.FC = () => {
  const { routerStore, vocStore, globalStore } = useRootStore()
  const [textValues, setTextValues] = useState('')
  const [checked, setChecked] = useState(false)
  const [classNameBtn, setClassNameBtn] = useState('voc-img-03')
  const [activeBtn, setActiveBtn] = useState(false)

  const sendClick = async () => {
    if (textValues.length > 0 && activeBtn) {
      await vocStore.attendVocAnswer(textValues, checked)
      if (isMobile) {
        routerStore.goBack()
      } else {
        globalStore.setVisiblePCVocPopup(false)
      }
    }
  }

  const updateBtnActive = () => {
    if (textValues.length > 0 &&
      activeBtn) {
      setClassNameBtn('voc-page-btn active')
    } else {
      setClassNameBtn('voc-page-btn')
    }
  }

  const onChange = (e) => {
    setTextValues(e.target.value)
  }

  const onClickYes = () => {
    setChecked(true)
    setActiveBtn(true)
  }

  const onClickNo = () => {
    setChecked(false)
    setActiveBtn(true)
  }

  useEffect(() => {
    updateBtnActive()
  })

  useOnMount(() => {
    if (isMobile) {
      setTimeout(() => {
        appScrollTo(1)
      }, 0)
    }
  })

  useOnUnmount(async ()=>{
    await vocStore.attendVoc()
  })


  return (
    <VocPageWrap>
      <TitleWrap className="title-wrap no-bg">
        {isMobile && (
          <BackBtn onClick={async () => {
            routerStore.goBack()
          }}>
            <ArrowIco/>
          </BackBtn>
        )}
      </TitleWrap>
      <img src={TopPageImg} alt="" className="voc-top-img"/>
      <div className="voc-contents">
        <img src={VocImg01} alt="" className="voc-img-01"/>
        <div className="voc-page-survey">
          <div className="voc-page-survey--txt">
            <img src={VocImg02} alt="" className="voc-img-02"/>
            <span>승부사온라인 이용시,<br/>어떠셨나요?</span>
          </div>
          <textarea name="vocEventInput" id="vocEventInput" cols={30} rows={10} placeholder="이용하며 느낀점, 건의사항 등 하고 싶은 말을 적어주세요^^" className="voc-page-textarea" value={textValues} onChange={onChange}/>
        </div>
        <div className="voc-page-check-box-tit">승부사온라인이 더 나은 서비스 제공을 위해 <br/>노력한다면, <span className="voc-point-color">계속 이용할 생각이</span></div>
        <ul className="voc-page-check-box">
          <li>
            <label htmlFor="yes">
              <input type="radio" name="select" value="yes" id="yes" onClick={onClickYes}/>
              <img src={CheckOff} alt="체크박스 비활성화" className="img check off"/>
              <img src={CheckOn} alt="처크박스 활성화" className="img check on"/>
              <span className="check-box-txt" style={{ marginRight: 69 }}>있다</span>
            </label>
          </li>
          <li>
            <label htmlFor="no">
              <input type="radio" name="select" value="no" id="no" onClick={onClickNo}/>
              <img src={CheckOff} alt="처크박스 비활성화" className="img check off"/>
              <img src={CheckOn} alt="처크박스 활성화" className="img check on"/>
              <span className="check-box-txt">없다</span>
            </label>
          </li>
        </ul>
        <img src={VocImg03} alt="" className="voc-img-03"/>
        {/* *************** 버튼 활성화 시 class 'active'를 추가하셔야 합니다. *************** */}
        <Button className={classNameBtn} onClick={sendClick}>전달</Button>
      </div>
    </VocPageWrap>
  )
}

export default observer(VocPage)
